// DS4.8 - Slider Variant
import React from 'react';
import c from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Slider, { DefaultPreviousButton, DefaultNextButton } from '@wix/da-ds/pkg/Slider';
import s from './FacetListRow.scss';
/**
 *
 * Included in da-shared-react because it relies on Slider
 */ const FacetListRow = ({ facets, className })=>{
    return /*#__PURE__*/ React.createElement(Slider, {
        className: c(s['root'], className),
        contentClassName: s['content'],
        renderPrevButton: ({ onClick, className: prevButtonClassName })=>/*#__PURE__*/ React.createElement(DefaultPreviousButton, {
                onClick: onClick,
                className: c(prevButtonClassName, s['prev-button']),
                arrowSize: IconSize.SMALLER
            }),
        renderNextButton: ({ onClick, className: nextButtonClassName })=>/*#__PURE__*/ React.createElement(DefaultNextButton, {
                onClick: onClick,
                className: c(nextButtonClassName, s['next-button']),
                arrowSize: IconSize.SMALLER
            }),
        permArrows: true,
        noSpacing: true
    }, facets);
};
FacetListRow.displayName = 'FacetListRow';
export default FacetListRow;
